<div
  class="flex flex-grow flex-col border rounded py-2 px-4"
  [ngClass]="{
    'bg-red-100 border-red-800 text-red-800': type === 'error',
    'bg-green-100 border-green-800 text-green-800': type === 'success',
    'bg-blue-100 border-blue-800 text-blue-800': type === 'info',
    'bg-yellow-100 border-yellow-800 text-yellow-800': type === 'warning'
  }"
>
  @if (message) {
    <div class="flex flex-col justify-start items-start">
      <p class="font-bold">{{ title }}</p>
      <p>{{ message }}</p>
    </div>
  }
  <ng-content></ng-content>
</div>
